<template>
    <img v-if="imageFound" :src="url" class="hero" alt="hero image" @error="failedLoading" />
    <div v-else class="backup-container">
        <img :src="backupUrl" class="backup-hero" alt="hero image" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class LoginHero extends Vue {

    imageFound: boolean = true;
    url: string | undefined = this.$whitelabel.resources.loginHero;
    backupUrl: string = this.$whitelabel.resources.logo;

    created() {
        if (!this.url) {
            this.failedLoading();
        }
    }

    failedLoading() {
        this.imageFound = false;
    }

}
</script>

<style scoped>
.backup-hero {
    max-width: 100%;
    max-height: 100%;
}
.backup-container {
    display: flex;
    width: 480px;
    height: 408px;
}
</style>
